import axios from 'axios';
import Vue from 'vue';
var axiosInstance = axios.create({
  baseURL: process.env.API_URL,
  withCredentials: true,
  headers: {
    Accept: 'application/json'
  }
});
Vue.prototype.$axios = axiosInstance;
export { axiosInstance };